import React from 'react'
import { useController } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { Box } from '../../../../legacy-design-system/form'
import { JiraFormFieldTypes } from './jira-form-field-types'
import { Radio } from '@contrast-security-inc/design-system-inputs'
import { Stack } from '@contrast-security-inc/design-system-layouts'

export const ProductSelectionField = () => {
  const { formatMessage } = useIntl()

  const {
    field: { onChange, value: isServerless }
  } = useController({ name: JiraFormFieldTypes.SERVERLESS })

  const assessLabel = formatMessage({
    id: 'title_integrationsSettings_productAssess'
  })
  const serverlessLabel = formatMessage({
    id: 'title_integrationsSettings_productServerless'
  })

  return (
    <Box basis={10}>
      <Stack flexDirection="column" spacing={'0px'}>
        <Radio
          label={assessLabel}
          isChecked={!isServerless}
          testId="product-assess-radio"
          onChange={() => {
            onChange(false)
          }}
        />
        <Radio
          label={serverlessLabel}
          isChecked={isServerless}
          testId="product-serverless-radio"
          onChange={() => {
            onChange(true)
          }}
        />
      </Stack>
    </Box>
  )
}
